<ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div cdkDragHandle class="mep-dialog-header-icon">
		<mat-icon> file_copy</mat-icon>
	</div>

	<div class="mep-dialog-title">
		<span>{{ _lang("heading") }}</span>
		<mat-icon [matTooltip]="_lang('dialog-explanation')" class="mep-dialog-title-side_icon"> info</mat-icon>
	</div>

	<div class="pb-3 full-height-dialog-content top-bottom-flex mep-dialog-content" mat-dialog-content>
		<div>
			@if (loading) {
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			}
			<div class="input-wrapper">
				<!-- Projekt auswählen -->
				<h3>{{ _lang("choose-project") }}</h3>
				<mat-form-field>
					<mat-label>{{ _lang("source-project") }}</mat-label>
					<input
						#sourceProjectInput
						[matAutocomplete]="autoSource.matAutocomplete"
						[ngModel]="sourceProject"
						matInput
						required
					/>
					<app-project-autocomplete
						#autoSource
						(elementSelected)="onSourceProjectChanged($event)"
						[inputElement]="sourceProjectInput"
						[overflow]="false"
					></app-project-autocomplete>
				</mat-form-field>

				<mat-icon> arrow_forward</mat-icon>

				<mat-form-field>
					<mat-label>{{ _lang("destination-project") }}</mat-label>
					<input
						#destinationProjectInput
						[matAutocomplete]="autoDestination.matAutocomplete"
						[ngModel]="destinationProject"
						matInput
						required
					/>
					<app-project-autocomplete
						#autoDestination
						(elementSelected)="onDestinationProjectChanged($event)"
						[inputElement]="destinationProjectInput"
						[overflow]="false"
					></app-project-autocomplete>
				</mat-form-field>
			</div>
			<div class="input-wrapper">
				<mat-form-field class="noAdditionalPadding">
					<mat-label>{{ _lang("default-effective-from") }}</mat-label>
					<input
						(dateChange)="onDefaultEffectiveFromChanged($event.value)"
						[(ngModel)]="defaultEffectiveFrom"
						[disabled]="!destinationProject || !sourceProject"
						[matDatepicker]="pickerFrom"
						appOnlyNumbers
						autocomplete="off"
						matInput
					/>
					<mat-datepicker-toggle [for]="pickerFrom" matSuffix></mat-datepicker-toggle>
					<mat-datepicker #pickerFrom [startAt]="defaultEffectiveFrom ? defaultEffectiveFrom : today"></mat-datepicker>
				</mat-form-field>

				<mat-icon></mat-icon>

				<mat-form-field class="noAdditionalPadding">
					<mat-label>{{ _lang("default-effective-until") }}</mat-label>
					<input
						(dateChange)="onDefaultEffectiveUntilChanged($event.value)"
						[(ngModel)]="defaultEffectiveUntil"
						[disabled]="!destinationProject || !sourceProject"
						[matDatepicker]="pickerUntil"
						appOnlyNumbers
						autocomplete="off"
						matInput
					/>
					<mat-datepicker-toggle [for]="pickerUntil" matSuffix></mat-datepicker-toggle>
					<mat-datepicker
						#pickerUntil
						[startAt]="defaultEffectiveUntil ? defaultEffectiveUntil : today"
					></mat-datepicker>
				</mat-form-field>
			</div>

			<small>{{ _lang("default-value-explanation") }}</small>

			@if (sourceProject && noAssignments) {
				<h3 class="mt-4">{{ _lang("no-assignments") }}</h3>
			}

			<div [class.d-none]="noAssignments || !sourceProject" class="mat-elevation-z3 mt-5">
				<app-assignment-table [project]="destinationProject"></app-assignment-table>
			</div>
		</div>
		<div class="bottom-flex">
			<mat-checkbox [(ngModel)]="removeSourceProject" matTooltip="{{ _lang('remove-source-project-tooltip') }}"
				>{{ _lang("remove-source-project") }}
			</mat-checkbox>
		</div>
	</div>

	<div class="mep-dialog-actions">
		<button (click)="closeDialog()" appEscapeHotkey class="mep-btn-dialog-secondary">{{ _lang("cancel") }}</button>
		<button
			(click)="saveChanges()"
			[disabled]="
				!selectedProjectsValid ||
				loading ||
				!newAssignmentTable?.selectedEmployeeAssignmentsAreValid() ||
				!newAssignmentTable?.isRowSelected()
			"
			class="mep-btn-dialog-primary"
		>
			{{ _lang("copy") }}
		</button>
		<button
			(click)="move()"
			[disabled]="
				!selectedProjectsValid ||
				loading ||
				!newAssignmentTable?.selectedEmployeeAssignmentsAreValid() ||
				!newAssignmentTable?.isRowSelected()
			"
			class="mep-btn-dialog-primary"
		>
			{{ _lang("move") }}
		</button>
	</div>
</ng-container>
